import { motion } from 'framer-motion';
import React from 'react'
import styled from 'styled-components';

const TextAnimation = ({children, direction, margin, opacity, delay}) => {
  const dir = {
    left:{ 
      start:{marginLeft: margin[0], opacity: opacity[0]},
      stop:{marginLeft: margin[1], opacity: opacity[1]}
     },
     top:{ 
      start:{marginTop: margin[0], opacity: opacity[0]},
      stop:{marginTop: margin[1], opacity: opacity[1]}
     },
  }
  return (
    <TextContainer
    as={motion.div}
    initial={dir[direction].start}
    whileInView={dir[direction].stop}
    transition={{ease:'anticipate',delay:0.2 * delay, duration:2}}
    viewport={{ once: true }}
    >
        {children}
    </TextContainer>
  )
}

export default TextAnimation;

let TextContainer = styled.div`
  
`